import { StateSetter } from 'react';
import { useLang } from 'hooks/lang';

import { ProjectTag } from 'entities';

import { Tag, Column, Row, TitledCard, Box, IconButton } from 'components/Blocks';

import { PencilIcon } from 'components/Icons';

import { ProjectTagStatus } from './Status';

import { useTeamProfile } from '../context';

export function ProjectTagCards({
  setFocusedTag,
}: {
  setFocusedTag: StateSetter<ProjectTag | null>;
}) {
  const { t } = useLang();
  const { team, canMutateEntities } = useTeamProfile();

  if (!team.projectTags.length) return <p className="text-center">{t('no-tags-found')}</p>;

  return (
    <Column>
      {team.projectTags.map((tag) => (
        <TitledCard
          title={tag.name}
          titleClassName="text-lg"
          key={tag.name}
          headerRightContent={
            <Row gap="2">
              <ProjectTagStatus tag={tag} />

              {canMutateEntities && (
                <IconButton
                  className="text-primary"
                  tooltipContent={t('update')}
                  onClick={() => setFocusedTag(tag)}
                >
                  <PencilIcon />
                </IconButton>
              )}
            </Row>
          }
        >
          <Row>
            <strong>{t('color')}:</strong>

            <Box size={18} backgroundColor={tag.color} border="rounded" />
          </Row>

          <Row>
            <strong>{t('preview')}:</strong>

            <Tag {...tag} className="text-white" />
          </Row>
        </TitledCard>
      ))}
    </Column>
  );
}
